import React, { useContext } from "react"; //
import {
  //
  bearlog,
  BearBalance,
  BearDiv,
  BearList,
  BearFloat,
  BearBorder,
} from "@sillyscribe95/bear-ui-web";
import { MainContext } from "../context/MainContext";
import { onChordMain } from "../functions/keyPress";
import { getChordMain, getNoteScale } from "../functions/keyFuncs";

export function ChordGrid(sdfers) {
  const { itemName } = sdfers;
  const number = itemName;
  bearlog.lug(`___ number ___`, number);

  const { playChordMain, playChord, picho } = useContext(MainContext);

  let minBase = {
    1: "maj",
    2: "min",
    3: "min",
    4: "maj",
    5: "maj",
    6: "min",
    7: "min",
    8: "maj",
  }[number];

  const ezksda = minBase === "maj" ? "min" : "maj";

  // minBase = minBase? ["min", "maj"] : ["min", "maj"]

  const list = [
    //
    // "maj",
    ezksda,
    // "min",
    // "maj7",
    // "sus4",
  ];

  const itemConfig = {
    style: {
      //
      margin: "5px",
      ...BearBorder("white", "50%"),
      padding: "20px",
    },
    className: "buttonHover",
  };

  function renderItem({ itemName }) {
    return reaawew(itemName);
  }

  function reaawew(akfewrw) {
    bearlog.lug(`___ akfewrw ___`, akfewrw);

    const obj = `${number}${akfewrw}`;
    function onClick() {
      click({ itemName: akfewrw });
    }
    return BearDiv({ obj, onClick, ...itemConfig });
  }

  const jasdfe =
    //
    getNoteScale(number, "major", 60 + picho);

  function click({ itemName }) {
    const getChordo =
      //
      // "";
      getChordMain(jasdfe, itemName);

    bearlog.lug(`___ getChordo ___`, { itemName, getChordo });

    playChordMain(getChordo);
    // playChord(jasdfe);
  }

  // 1console
  bearlog.lug(`___ jasdfe ___`, {
    number,
    jasdfe,
  });

  const left = reaawew(minBase);

  const right = BearList({
    horiz: true,
    bearName: "Afowera",
    list,
    fontSize: "0.7em",
    // itemConfig,
    // dictvar
    renderItem,
  });

  const flotoe = BearFloat({
    left,
    right,
  });

  const balano = BearBalance(left, right, {
    fontSize: "4vh",
  });

  const res =
    //
    balano;
  // flotoe

  return res;
}
